// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 519) return "static/chunks/maplibre-435c32ed815df56d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "524f35487fcd2b22" + ".js";
};